const getActivityNumber = (draft) => {
  if (!draft) return "";
  console.log(draft, "draft");
  const entry = draft.find((item) => {
    if (item.action !== "Send to HNTB" || !item.formData) return false;
    try { const p = JSON.parse(item.formData[1] || "[]"); return p[0] && p[0].activity_number; }
    catch (_) { return false; }
  });
  return entry?.formData?.[0] || "";
};

export default getActivityNumber;
